import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { throwError } from "rxjs";
import { map, catchError } from "rxjs/operators";

import { Occupation } from '../../models/admin-models/occupation.model';
import { Filter } from '../../models/filter.model';

@Injectable({
    providedIn: 'root'
})
export class OccupationService {

    constructor(private httpClient: HttpClient) { }

    getOne(id: Number) {
        return this.httpClient.get('api/occupations/' + id).toPromise();
    }

    gridView(filter: Filter) {
        return this.httpClient.post('api/occupations/gridview', filter.data)
            .pipe(
                map((res: any) => {
                    return res.data;
                }),
                catchError((error) => {
                    return throwError(error);
                })
            )
    }

    createOccupation(occupation: Occupation) {
        return this.httpClient.post('api/occupations/create', occupation.data).toPromise();
    }

    editOccupation(occupation: Occupation) {
        return this.httpClient.post('api/occupations/edit', occupation.data).toPromise();
    }

    deleteOccupation(ids: Array<Number>) {
        return this.httpClient.post('api/occupations/delete', ids).toPromise();
    }

}